import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import axios from "axios";

import "./Weather.css";

export default function Weather(props) {
    const [weatherData, setWeatherData] = useState({ ready: false });
    const [city, setCity] = useState(props.defaultCity);

    function handleResponse(response) {
        setWeatherData({
            ready: true,
            date: new Date(response.data.dt * 1000),
            lat: response.data.coord.lat,
            lon: response.data.coord.lon,
            temperature: response.data.main.temp,
            wind: response.data.wind.speed,
            humidity: response.data.main.humidity,
            pressure: response.data.main.pressure,
            description: response.data.weather[0].description,
            icon: response.data.weather[0].icon,
            city: response.data.name
        });
    }

    function search() {
        const apiKey = "8ecc86cdab2b9052d408be7ad226b471";
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
        axios.get(apiUrl).then(handleResponse);
    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    function handleCityChange(event) {
        setCity(event.target.value);
    }

    if (weatherData.ready) {
        return (

            <div className="Weather">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-7">
                            <input type="search"
                                placeholder="Type your query.."
                                className="form-control"
                                autoFocus="on"
                                onChange={handleCityChange}
                            />
                        </div>

                        <div className="col-3">
                            <input type="submit"
                                value="Search"
                                className="btn btn-outline-primary "
                            />
                        </div>
                    </div>
                </form>

                <WeatherInfo data={weatherData} />
                <br />
                <hr />

                <WeatherForecast city={weatherData.city} />
            </div>
        );

    } else {
        search();
        return "Loading..";
    }
}
